import { render, staticRenderFns } from "./ProfitLossChart.vue?vue&type=template&id=efdebe70&scoped=true&"
import script from "./ProfitLossChart.vue?vue&type=script&lang=js&"
export * from "./ProfitLossChart.vue?vue&type=script&lang=js&"
import style0 from "./ProfitLossChart.vue?vue&type=style&index=0&id=efdebe70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdebe70",
  null
  
)

export default component.exports